import { render, staticRenderFns } from "./offineSumbit.vue?vue&type=template&id=563ef8c6&scoped=true&"
import script from "./offineSumbit.vue?vue&type=script&lang=js&"
export * from "./offineSumbit.vue?vue&type=script&lang=js&"
import style0 from "./offineSumbit.vue?vue&type=style&index=0&id=563ef8c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ef8c6",
  null
  
)

export default component.exports